import React, { useState, useMemo } from 'react'
import DataTable, { TableColumn } from 'react-data-table-component'
import { Card, Form } from 'react-bootstrap'

interface ClickDataTableProps<T> {
    title: string
    columns: TableColumn<T>[]
    data: T[]
}

export function ClickDataTable<T extends { [key: string]: any }>({
    title,
    columns,
    data,
}: ClickDataTableProps<T>) {
    const [filterText, setFilterText] = useState('')

    const filteredData = useMemo(() => {
        if (!filterText) return data
        return data.filter(row =>
            Object.values(row)
                .join(' ')
                .toLowerCase()
                .includes(filterText.toLowerCase())
        )
    }, [data, filterText])

    return (
        <Card className="mb-3 shadow-sm">
            <Card.Body>
                <h5>{title}</h5>
                <div style={{ width: '50%', marginBottom: '0.5rem' }}>
                    <Form.Group controlId={`${title}-search`}>
                        <Form.Control
                            type="text"
                            placeholder="Search..."
                            value={filterText}
                            onChange={e => setFilterText(e.target.value)}
                            size='sm'
                        />
                    </Form.Group>
                </div>
                <div style={{ height: '250px', overflowY: 'auto' }}>
                    <DataTable
                        columns={columns}
                        data={filteredData}
                        pagination
                        defaultSortFieldId={'clicks'}
                        defaultSortAsc={false} // descending
                        highlightOnHover
                        dense
                        responsive
                    />
                </div>
            </Card.Body>
        </Card>
    )
}
